export default __webpack_public_path__ + "static/media/division-3.069f0102.png";